// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rmep","largestCol":"styles_largestCol__3fh1Q","smallestCol":"styles_smallestCol__VxjmQ"};